import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import VueAxios from 'vue-axios';
import es from 'vee-validate/dist/locale/es'
import VeeValidate, { Validator } from 'vee-validate';
import VueCookie from 'vue-cookie';
import VModal from 'vue-js-modal'
import Notifications from 'vue-notification'
import Loading from 'vue-loading-overlay';
import CKEditor from "@ckeditor/ckeditor5-vue2";
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.router = router
Vue.use(VueAxios, axios);
Validator.localize('es', es);
Vue.use(VeeValidate);
Vue.use(VueCookie);
Vue.use(VModal,{ dynamic: true, dialog: true })
Vue.use(Notifications)
Vue.use(Loading,{color: '#7ac043'});
Vue.use(CKEditor);

//Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
Vue.axios.defaults.baseURL = 'https://clients.crbox.cr';


Vue.use(require('@websanova/vue-auth'), {
  auth: require('./tokendriver/crbox.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  loginData: {
    url: 'authtoken', method: 'POST', redirect: '/dashboard', fetchUser: false,
    headers: {'Content-Type': 'application/x-www-form-urlencoded', "Cache-Control": "no-cache",},
    
    crossOrigin: false,
  },
  refreshData: {enabled: false, interval: 0},
  fetchData: {enabled: false},
  notFoundRedirect: false,
  authRedirect: {path: '/client'},
  tokenDefaultName: 'crboxapplicationtkn',
  tokenStore: ['localStorage', 'cookie']
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')